module.exports = __webpack_public_path__ + "static/media/protip-slide-1.e6e51c45.jpg";